import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-card pt-20 pb-10 px-6 border-t border-border" data-id="element-72">
      <div className="container max-w-[1100px] mx-auto" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-74">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-75">
            <h3 className="font-serif text-3xl text-foreground mb-4" data-id="element-76">
              Paola Rojas
            </h3>
            <p className="text-muted-foreground font-light text-sm max-w-xs leading-relaxed" data-id="element-77">
              Acompañando a mujeres a sanar, elevar sus estándares y volver a su
              esencia.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-78">
            <h4 className="text-xs uppercase tracking-[0.2em] text-accent mb-6" data-id="element-79">
              Legal
            </h4>
            <ul className="space-y-4" data-id="element-80">
              <li data-id="element-81">
                <Link to="/privacidad" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-82">
                  Política de Privacidad
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/terminos" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-84">
                  Términos y Condiciones
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/reembolsos" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-86">
                  Política de Reembolsos
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-87">
            <h4 className="text-xs uppercase tracking-[0.2em] text-accent mb-6" data-id="element-88">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-89">
              <li data-id="element-90">
                <Link to="/contacto" className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-3" data-id="element-91">
                  <Mail className="w-4 h-4" data-id="element-92" />
                  hola@paolarojas.com
                </Link>
              </li>
              <li data-id="element-93">
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-3" data-id="element-94">
                  <Instagram className="w-4 h-4" data-id="element-95" />
                  @paolarojassv
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border/50 text-center" data-id="element-96">
          <p className="text-xs text-muted-foreground/60 tracking-widest uppercase" data-id="element-97">
            © 2026 Paola Rojas · Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>;
}